import { render, staticRenderFns } from "./BaseDataTableTable.vue?vue&type=template&id=19562ef6&scoped=true"
import script from "./BaseDataTableTable.vue?vue&type=script&lang=js"
export * from "./BaseDataTableTable.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTableTable.vue?vue&type=style&index=0&id=19562ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19562ef6",
  null
  
)

export default component.exports